import moment from 'moment';
import {useMemo} from 'react';
import {useSearchParams} from '../../../../hooks/use-search-params';

export function useShiftDetailsSearchParams() {
  const searchParams = useSearchParams();

  const params = useMemo(() => {
    const date = searchParams.get('date') ?? moment().format('YYYY-MM-DD');
    const start = searchParams.get('start') ?? '00:00:00';
    const end = searchParams.get('end') ?? '23:59:59';
    let startDate = moment(date + 'T' + start);
    let endDate = moment(date + 'T' + end);

    // If endDate is before startDate, then it's the next day.
    if (endDate.isBefore(startDate)) {
      endDate = endDate.add(1, 'day');
    }

    const result = {
      startDate,
      endDate,
      date: moment(date).startOf('day'),
      entityShiftId: searchParams.get('entityShiftId'),
      groupTime: searchParams.get('groupTime'),
      groupName: searchParams.get('groupName'),
      careServiceUserId: searchParams.get('careServiceUserId'),
    };

    return result;
  }, [searchParams]);

  return params;
}
